import type { ReactElement } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logowtext.svg";
import { IconPix } from "../components/Icons";

const FEATURES = [
  {
    emoji: "⚡",
    title: "Lançar é rápido",
    text: "Valor, quem pagou, entre quem. Quatro toques e a conta está dividida.",
  },
  {
    emoji: "👻",
    title: "Ninguém precisa se cadastrar",
    text: "Adicione a galera só pelo nome. Se alguém criar conta depois, é só vincular.",
  },
  {
    emoji: "🧮",
    title: "Divisão do jeito que foi",
    text: "Igual, por peso, valor exato ou item a item — e dá para bancar a parte de alguém.",
  },
  {
    emoji: "🔗",
    title: "Um link e acabou",
    text: "Mande o link do rolê: cada um vê quanto deve e copia o Pix na hora.",
  },
];

export function LandingPage(): ReactElement {
  return (
    <div className="landing">
      <main className="landing-hero">
        <img className="landing-logo" src={logo} alt="Caloteiros" />
        <h1 className="landing-title">
          Divida a conta, <strong>mantenha os amigos</strong>.
        </h1>
        <p className="landing-subtitle">
          Registre as despesas do rolê, veja na hora quem deve para quem e receba com a
          sua chave Pix <IconPix style={{ display: "inline-block", verticalAlign: "-0.15em" }} width={18} height={18} />{" "}
          na tela de todo mundo.
        </p>

        <div className="landing-actions">
          <Link className="btn btn-primary" to="/criar-conta">
            Criar conta
          </Link>
          <Link className="btn btn-ghost" to="/entrar">
            Entrar
          </Link>
        </div>

        <div className="landing-features">
          {FEATURES.map((feature) => (
            <div key={feature.title} className="landing-feature">
              <span className="landing-feature-emoji" aria-hidden="true">
                {feature.emoji}
              </span>
              <div>
                <strong>{feature.title}</strong>
                <p className="muted">{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </main>

      <footer className="landing-footer">
        <span>João Pedro Borges · 2026</span>
        <nav>
          <a
            href="https://github.com/jpgborges"
            target="_blank"
            rel="noopener"
            aria-label="GitHub"
          >
            <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
              <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/jpgborges"
            target="_blank"
            rel="noopener"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793 0 1.44.645 1.44 1.439z" />
            </svg>
          </a>
        </nav>
      </footer>
    </div>
  );
}
